/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ periode: NonNullable<unknown> }} Planning_Api_Errors_Vrije_Dag_OverlaptInputs */

const nl_planning_api_errors_vrije_dag_overlapt = /** @type {(inputs: Planning_Api_Errors_Vrije_Dag_OverlaptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Valt al in ${i?.periode}.`)
};

/**

* @param {Planning_Api_Errors_Vrije_Dag_OverlaptInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_api_errors_vrije_dag_overlapt = /** @type {((inputs: Planning_Api_Errors_Vrije_Dag_OverlaptInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Api_Errors_Vrije_Dag_OverlaptInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_api_errors_vrije_dag_overlapt(inputs)
});
export { planning_api_errors_vrije_dag_overlapt as "planning.api_errors.vrije_dag_overlapt" }